import React, { useState } from 'react';
import './contacto.css';
import linkedin from '../Nav/icono link.png';
import git from '../Nav/icono git.png';
import correo from '../Nav/icono correo.png';

const TEXTS = {
  es: {
    title: "Hablemos",
    body: (
      <>
        ¿Tenés un proyecto en mente o necesitás un desarrollador front-end confiable?
        <br />
        Estoy disponible para trabajos freelance o posiciones full-time.
      </>
    ),
    footer: "Respondo rápido y me adapto a distintos tipos de proyectos."
  },
  en: {
    title: "Let’s talk",
    body: (
      <>
        Do you have a project in mind or need a reliable front-end developer?
        <br />
        I’m available for freelance work or full-time positions.
      </>
    ),
    footer: "I reply quickly and adapt to different types of projects."
  }
};

function Contacto() {
  const [lang, setLang] = useState("es");
  const t = TEXTS[lang];

  return (
    <div className="contacto-outer">
      <div className="contacto-container card">

        {/* Language toggle */}
        <div className="contacto-lang">
          <button
            className={`lang-btn ${lang === "es" ? "active" : ""}`}
            onClick={() => setLang("es")}
          >
            ES
          </button>
          <button
            className={`lang-btn ${lang === "en" ? "active" : ""}`}
            onClick={() => setLang("en")}
          >
            EN
          </button>
        </div>

        <h1 className="contacto-title">{t.title}</h1>

        <p className="contacto-texto">{t.body}</p>

        <div className="contacto-redes">
          <a
            href="https://www.linkedin.com/in/v%C3%ADctor-barreto-486487255/"
            target="_blank"
            rel="noopener noreferrer"
            className="contacto-link"
          >
            <img src={linkedin} alt="LinkedIn" className="contacto-icono" />
            <span>LinkedIn</span>
          </a>

          <a
            href="https://github.com/vapretito"
            target="_blank"
            rel="noopener noreferrer"
            className="contacto-link"
          >
            <img src={git} alt="GitHub" className="contacto-icono" />
            <span>GitHub</span>
          </a>
        </div>

        <div className="contacto-email">
          <img src={correo} alt="Email" className="correo-icono" />
          <a href="mailto:titomanbarreto@gmail.com" className="correo-texto">
            titomanbarreto@gmail.com
          </a>
        </div>

        <p className="contacto-footer">{t.footer}</p>
      </div>
    </div>
  );
}

export default Contacto;
